var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"section docScroll mt-6",attrs:{"id":"step_3_pay_on_payfast"}},[_c('SectionColumn',{attrs:{"type":"left","title":"Step 3: Send the customer to Payfast for payment","content":_vm.contentIntroLeft}}),_c('SectionColumn',{attrs:{"type":"right","content":_vm.contentIntroRight}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }